"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayNowMockStates = void 0;
var PayNowMockStates;
(function (PayNowMockStates) {
    // Repayments (2nd, 3rd, etc. payment)
    PayNowMockStates["REPAY_NOW"] = "repayNow";
    PayNowMockStates["REPAY_NOW_MULTIPLE_REPAYMENTS"] = "repayNowMultipleRepayments";
    PayNowMockStates["REPAY_NOW_FAILED"] = "repayNowFailed";
    // Downpayment - Flex Anywhere
    PayNowMockStates["RENT_PAID_OON_REPAY_NOW_FAILED"] = "rentPaidOonRepayNowFailed";
    PayNowMockStates["RENT_PAID_OON_REPAY_NOW_429"] = "rentPaidOonRepayNow429";
    // Downpayment - Flex Classic
    PayNowMockStates["PRE_FUND_FIRST_PAYMENT"] = "preFundFirstPayment";
    PayNowMockStates["RESCHEDULE_PAYMENT"] = "reschedulePayment";
    // Outstanding balance
    PayNowMockStates["CANCELED_DQ"] = "canceledDQ";
    PayNowMockStates["PAUSED_DQ"] = "pausedDQ";
    PayNowMockStates["SUSPENDED_DQ"] = "suspendedDQ";
    PayNowMockStates["SUSPENDED_DQ_FAILED"] = "suspendedDQFailed";
    PayNowMockStates["ACTIVE_ROLLOVER_PROGRAM"] = "activeRolloverProgram";
    PayNowMockStates["CANCELED_2ND_PAYMENT_UNPAID"] = "canceled2ndPaymentUnpaid";
})(PayNowMockStates || (exports.PayNowMockStates = PayNowMockStates = {}));
